<template>
  <v-card flat tile>
    <v-card-title>
      CFEs
      <v-spacer />
      <v-text-field
        v-model="search"
        clearable
        flat
        hide-details
        label="Search"
        :prepend-icon="icons.search"
        single-line
        solo-inverted
      />
      <v-btn depressed class="ml-2" @click="createItem()">
        Add Document
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-data-table :headers="header" :items="items" :search="search">
      <!--
        select-all
        v-model="selected"
      -->
      <v-progress-linear slot="progress" color="blue" indeterminate />
      <template v-slot:item="{ item }">
        <!--
        <td>
          <v-checkbox
            v-model="props.selected"
            primary
            hide-details
          ></v-checkbox>
        </td>
        -->
        <td>{{ item.name }}</td>
        <td>{{ item.originalName }}</td>
        <td>
          <v-chip v-for="slide in item.slides" :key="slide._id" dense label>
            {{ slide.name }}
          </v-chip>
        </td>
        <td>
          {{ formatTime(item.createdAt) }}
        </td>
        <td class="justify-center layout px-0">
          <v-icon class="mr-2 clickable" small @click="editItem(item)">
            edit
          </v-icon>
          <v-icon class="mr-2 clickable" small @click="deleteItem(item)">
            delete
          </v-icon>
          <v-icon class="clickable" small @click="downloadItem(item)">
            cloud_download
          </v-icon>
        </td>
      </template>
    </v-data-table>
    <v-divider />
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
//
import { confirm } from '@/utils/modal';
//
import { CFES_TABLE_HEADERS, DELETE_CFE, GET_CFES, UPDATE_CFE, SHOW_CFE_MODAL } from '@/config/constants';
import icons from '../../mixins/icons';

export default {
  mixins: [icons],
  props: {
    highlighted: String
  },
  data() {
    return {
      selected: [],
      header: CFES_TABLE_HEADERS,
      search: this.highlighted || ''
    };
  },
  async created() {
    await this.$store.dispatch(GET_CFES);
  },
  computed: {
    ...mapState('documents', {
      items: state => state.cfes.items
    })
  },
  methods: {
    createItem() {
      this.$store.dispatch(SHOW_CFE_MODAL);
    },
    editItem(item) {
      this.$store.dispatch(SHOW_CFE_MODAL, item);
    },
    deleteItem(item) {
      confirm('CFE löschen', `Möchtest du das CFE "${item.name}" wirklich löschen?`, 'Ja', 'Nein').then(
        yes => {
          if (yes) {
            this.$store.dispatch(DELETE_CFE, item);
          }
        }
      );
    },
    async downloadItem(item) {
      await new DocumentService().download(item, `${item.originalName}`).then(link => {
        if (link) {
          link.click();
        } else {
          // TODO: error message
        }
      });
    },
    //
    onSelect(selected) {
      this.selected = selected;
      this.$emit('selected', selected);
    },
    formatTime(time) {
      return moment(time).format('DD.MM.YY kk:mm');
    }
  }
};
</script>
